/**
 * OAuth Callback Page
 * Handles the redirect from Azure Entra ID after authentication
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { msalInstance } from '../config/msalConfig';
import { Spinner } from '../components/Spinner';
import { consumeReturnUrl } from '../utils/returnUrl';

export const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        await msalInstance.initialize();
        const result = await msalInstance.handleRedirectPromise();

        if (result) {
          console.log('Login successful, account:', result.account);
        }

        const accounts = msalInstance.getAllAccounts();

        if (accounts.length > 0) {
          window.dispatchEvent(new Event('userLoggedIn'));

          const returnUrl = consumeReturnUrl();
          if (returnUrl) {
            navigate(returnUrl, { replace: true });
            return;
          }

          navigate('/', { replace: true });
        } else {
          console.warn('No accounts found after redirect');
          setError('Authentication failed. Please try logging in again.');
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        const errorMessage = err instanceof Error ? err.message : 'Authentication failed';
        setError(`Authentication error: ${errorMessage}`);
      }
    };

    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="login-container">
        <div className="login-form">
          <div className="login-header">
            <img src="/axis_website_logo_white.svg" alt="Axis" className="login-logo" />
            <h3>Authentication Error</h3>
          </div>

          <div className="alert alert-danger" style={{ marginBottom: '20px' }}>
            {error}
          </div>

          <button onClick={() => navigate('/login')} className="btn btn-primary btn-login">
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="login-header">
          <img src="/axis_website_logo_white.svg" alt="Axis" className="login-logo" />
          <h3>Completing Sign In</h3>
          <p>Please wait while we complete your authentication...</p>
        </div>

        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spinner size="lg" />
          <p style={{ marginTop: '20px', color: '#666' }}>
            Processing your login...
          </p>
        </div>
      </div>
    </div>
  );
};
